import * as types from './actionTypes';

export function setCurrFees(curr_fees){
  return {
    type: types.SET_CURR_FEES,
    curr_fees
  }
}

export function setOldFees(old_fees){
  return {
    type: types.SET_OLD_FEES,
    old_fees
  }
}
